<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="演出" name="1" link="/system/serviceTemplate/list"></el-tab-pane>
            <el-tab-pane label="周边" name="2" link="/system/serviceTemplate/goodslist"></el-tab-pane>
			<el-tab-pane label="其他" name="3" link="/system/serviceTemplate/otherlist"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>